import Link from 'next/link'
import { useRouter } from 'next/router'

import { classNames } from '../../../functions'

interface NavLinkProps {
  children?: any
  exact?: boolean
  activeClassName?: string
  [x: string]: any
  className?: string
}

const NavLink = ({
  className = '',
  children,
  exact = false,
  activeClassName = 'text-green-500',
  ...props
}: NavLinkProps) => {
  const { asPath } = useRouter()

  // pages/index.ts will be matched via props.href
  // pages/about.ts will be matched via props.href
  // pages/[slug].ts will be matched via props.as

  const isActive = exact
    ? (props.as || props.href.pathname || props.href) === asPath
    : asPath.startsWith(props.as || props.href.pathname || props.href)

  return (
    <Link
      className={classNames(isActive ? activeClassName : '', className)}
      href={props.href}
      {...props}
    >
      {children}
    </Link>
  )
}

export default NavLink
